import { render, staticRenderFns } from "./TariffZone.vue?vue&type=template&id=16085960&"
import script from "./TariffZone.vue?vue&type=script&lang=ts&"
export * from "./TariffZone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports